import EntityApi from "../Api/EntityApi";

class PageService {

    constructor(jsonApi, state) {
        this.entityApi = new EntityApi(jsonApi);
        this.jsonApi = jsonApi;
        this.state = state;

        this.state.add('page', null);
        this.state.add('errorMsg', '');
        this.state.add('loading', false);
    }

    fetchPage(name) {
        if (this.state.loading) {
            return;
        }
        this.state.setLoading(true);
        this.state.setErrorMsg('');
        this.entityApi.list('Page', 'content',
            (resultType, list, data) => {
                if (data.status === 'success') {
                    this.updateData(list);
                }

                this.state.setLoading(false);
            },
            (res) => {
                this.state.setLoading(false);
            },
            -1,
            {key: 'name', value: name});
    }

    updateData(list) {
        const page = list[0];
        page.snippets = page.blocks.length ? page.blocks[0].textSnippets.sort((a, b) => a.order - b.order) : [];

        this.state.setPage(page);
    }

    getBlock(blockName, fallbackIndex = -1) {
        const page = this.state.page;
        if (!page) {
            return null;
        }
        const filteredBlocks = page.blocks.filter(b => b.name === blockName);
        if (filteredBlocks) {
            return filteredBlocks[0];
        }
        return fallbackIndex > -1 && fallbackIndex < page.blocks.length ? page.blocks[fallbackIndex] : null;
    }

}

export default PageService;